exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app[data-v-1b77e298]{width:100%;height:100%\n}\n", ""]);

// exports
